import { render } from "./animationSnow.vue?vue&type=template&id=13253372&scoped=true"
import script from "./animationSnow.vue?vue&type=script&lang=js"
export * from "./animationSnow.vue?vue&type=script&lang=js"

import "./animationSnow.vue?vue&type=style&index=0&id=13253372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13253372"]])

export default __exports__